
export const Backward = (props : any) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 10.0002C17.5 10.594 17.0504 11.0738 16.4566 11.0738H6.16684L9.703 14.6099C10.1224 15.0293 10.1224 15.7087 9.703 16.1281C9.49163 16.3378 9.21653 16.4418 8.94142 16.4418C8.66631 16.4418 8.39187 16.3369 8.18252 16.1272L2.81453 10.7592C2.39516 10.3399 2.39516 9.66049 2.81453 9.24111L8.18252 3.87312C8.60189 3.45375 9.28128 3.45375 9.70065 3.87312C10.12 4.2925 10.12 4.97188 9.70065 5.39126L6.16684 8.92658H16.4566C17.0504 8.92658 17.5 9.40634 17.5 10.0002Z" fill={props.color || '#3333CC'} />
        </svg>
    );
}

